import React from 'react'

const Footer = () => {
  return (
    <div className="bg-gradient-to-b from-gray-800 to-black w-full h-auto text-white">
       <p className="text-center py-8  px-5 xl:text-lg text-sm text-gray-500">Copywrite by <span className="text-xl">©</span> EthicsWalaCoder  <span> | </span> Produced by - Artbangla Bazaar  {new Date().getFullYear()}</p>
    </div>
  )
}

export default Footer